<template>
    <bo-cell-number
        :decimal="decimal"
        :currency="currency"
        :negative="negative"
        :min="min"
        :max="max"
        :readonly="!editable"
        :editable="editable"
        :id="id"
        :value="value"
        :eager="eager"
        :inputStyle="inputStyle"
        @change="changedValue"
    ></bo-cell-number>
</template>

<script>
import Vue from "vue";
import boCellNumber from "@/v2/components/bo-cell-number.vue";

export default {
    components: { boCellNumber },
    props: {
        decimal: {
            type: Number,
            default: 2,
        },
        currency: {
            type: String,
            default: "RM",
        },
        negative: {
            type: Boolean,
            default: true,
        },
        min: {
            type: Number,
            default: Number.MIN_SAFE_INTEGER,
        },
        max: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        eager: {
            type: Boolean,
            default: false,
        },
        inputStyle: {
            type: [String, Array],
            default: "",
        },
    },

    model: {
        prop: "value",
        event: "change",
    },

    methods: {
        changedValue(value) {
            this.$emit("change", value);
        },
    },
};
</script>
